export const fallenConstants = {
  defaultImage:
    'https://IzkorImagesCDN.azureedge.net/assets/img/no_image_defult.jpg',
};
